import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card shadow-none border-0" }
const _hoisted_2 = {
  class: "card-header bg-primary text-light",
  id: "kt_gender_policy_list_header"
}
const _hoisted_3 = {
  class: "card-title fw-bolder text-light",
  style: {"font-size":"1.35rem !important"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-sm btn-icon btn-active-primary-light me-n5",
    id: "kt_gender_policy_drawer_close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-light" })
  ])
], -1)
const _hoisted_5 = {
  class: "card-body position-relative",
  id: "kt_gender_policy_list_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_gender_policy_list_body",
  "data-kt-scroll-dependencies": "#kt_gender_policy_list_header, #kt_gender_policy_list_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6 fv-row mb-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Ministry :")
], -1)
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = { class: "col-md-6 fv-row mb-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "GST Activity :")
], -1)
const _hoisted_12 = { class: "text-danger" }
const _hoisted_13 = { class: "col-md-12 fv-row mb-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Required Indicator :")
], -1)
const _hoisted_15 = { class: "text-danger" }
const _hoisted_16 = { class: "col-md-4 fv-row mb-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Baseline :", -1)
const _hoisted_18 = { class: "col-md-4 fv-row mb-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Annual Target :", -1)
const _hoisted_20 = { class: "col-md-4 fv-row mb-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Reporting Frequency :", -1)
const _hoisted_22 = { class: "col-md-12 fv-row mb-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, " Achievement (Reporting Period) : ", -1)
const _hoisted_24 = { class: "col-md-12 fv-row mb-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Cumulative Achievement :", -1)
const _hoisted_26 = { class: "col-md-12 fv-row mb-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Evidence/Source :", -1)
const _hoisted_28 = { class: "col-md-12 fv-row mb-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Challenges :", -1)
const _hoisted_30 = { class: "col-md-12 fv-row mb-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Government Priority :", -1)
const _hoisted_32 = { class: "col-md-6 fv-row mb-4" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Gender Budget 2026-27 :", -1)
const _hoisted_34 = { class: "col-md-6 fv-row mb-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, " Expenditure 2026-27 (as of reporting period) : ", -1)
const _hoisted_36 = { class: "col-md-12 fv-row mb-4" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Remarks :", -1)
const _hoisted_38 = { class: "col-md-6 fv-row mb-4" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Submit Date :", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 fv-row mb-4" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-lg btn-primary float-right",
    type: "submit"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Submit")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["prevent"])),
    id: "store_gender_policy_drawer",
    "data-kt-drawer": "true",
    "data-kt-drawer-activate": "true",
    "data-kt-drawer-name": "store_gender_policy_drawer",
    "data-kt-drawer-overlay": "true",
    "data-kt-drawer-direction": "end",
    "data-kt-drawer-toggle": "#kt_drawer_gender_policy_list",
    "data-kt-drawer-close": "#kt_gender_policy_drawer_close",
    "data-kt-drawer-width": "60%"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.formData.id ? "Update Report" : "Create Report"), 1),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_select, {
              modelValue: _ctx.formData.ministry,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.ministry) = $event)),
              name: "ministry",
              id: "ministry",
              class: "form-select-solid",
              filterable: "",
              "popper-append-to-body": "false",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  value: "",
                  selected: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Select Ministry...")
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ministryOptions, (option) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: option,
                    value: option,
                    label: option
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(option), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.errors.ministry), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_el_select, {
              modelValue: _ctx.formData.gst_activity,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.gst_activity) = $event)),
              name: "gst_activity",
              class: "form-select-solid",
              filterable: "",
              "allow-create": "",
              "popper-append-to-body": "false",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, { value: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Select...")
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gstActivityOptions, (option) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: option,
                    value: option,
                    label: option
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(option), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.errors.gst_activity), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.required_indicator) = $event)),
              name: "required_indicator",
              type: "text",
              class: "form-control form-control-solid",
              placeholder: "",
              readonly: ""
            }, null, 512), [
              [_vModelText, _ctx.formData.required_indicator]
            ]),
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.errors.required_indicator), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.baseline) = $event)),
              type: "text",
              class: "form-control form-control-solid",
              placeholder: ""
            }, null, 512), [
              [_vModelText, _ctx.formData.baseline]
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.annual_target) = $event)),
              type: "text",
              class: "form-control form-control-solid",
              placeholder: ""
            }, null, 512), [
              [_vModelText, _ctx.formData.annual_target]
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode(_component_el_select, {
              modelValue: _ctx.formData.reporting_frequency,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.reporting_frequency) = $event)),
              name: "reporting_frequency",
              class: "form-select-solid",
              filterable: "",
              "popper-append-to-body": "false",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, { value: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Select...")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_option, { value: "Quarterly" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Quarterly")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_option, { value: "Half-Yearly" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Half-Yearly")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_option, { value: "Yearly" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Yearly")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.achievement_reporting_period) = $event)),
              class: "form-control form-control-solid",
              placeholder: ""
            }, null, 512), [
              [_vModelText, _ctx.formData.achievement_reporting_period]
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.cumulative_achievement) = $event)),
              class: "form-control form-control-solid",
              placeholder: ""
            }, null, 512), [
              [_vModelText, _ctx.formData.cumulative_achievement]
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.evidence_source) = $event)),
              class: "form-control form-control-solid",
              placeholder: ""
            }, null, 512), [
              [_vModelText, _ctx.formData.evidence_source]
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.challenges) = $event)),
              class: "form-control form-control-solid",
              placeholder: ""
            }, null, 512), [
              [_vModelText, _ctx.formData.challenges]
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createVNode(_component_el_select, {
              modelValue: _ctx.formData.government_priority,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.government_priority) = $event)),
              name: "government_priority",
              class: "form-select-solid",
              filterable: "",
              multiple: "",
              "allow-create": "",
              "popper-append-to-body": "false",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.governmentPriorityOptions, (option) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: option,
                    value: option,
                    label: option
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(option), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.budget_2026_27) = $event)),
              type: "text",
              class: "form-control form-control-solid",
              placeholder: ""
            }, null, 512), [
              [_vModelText, _ctx.formData.budget_2026_27]
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.expenditure_2026_27) = $event)),
              type: "text",
              class: "form-control form-control-solid",
              placeholder: ""
            }, null, 512), [
              [_vModelText, _ctx.formData.expenditure_2026_27]
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.remarks) = $event)),
              class: "form-control form-control-solid",
              placeholder: ""
            }, null, 512), [
              [_vModelText, _ctx.formData.remarks]
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.submit_date) = $event)),
              type: "date",
              class: "form-control form-control-solid",
              placeholder: ""
            }, null, 512), [
              [_vModelText, _ctx.formData.submit_date]
            ])
          ]),
          _hoisted_40
        ])
      ])
    ])
  ], 32))
}